const translator = {
  video: 'فایل ویدیو',
  audio: 'فایل صوتی',
  pdf: 'فایل PDF',
  word: 'فایل ورد',
  powerpoint: 'فایل پاورپوینت',
  image: 'فایل تصویر',
  answerType: 'نوع پاسخ مجاز برای آپلود توسط دانش آموز',
  allowDelay: 'آیا تاخیر در آپلود مجاز باشد',
  delayEnd: 'آخرین مهلت آپلود با تاخیر',
  delayPenalty: 'جریمه هر روز تاخیر در آپلود (به درصد)',
  maxUploadSize:
    'حداکثر حجم مجاز برای آپلود توسط دانش آموز (به مگابایت - بیشترین مقدار ممکن 20MB)',
  name: 'نام تمرین',
  finalize: 'نهایی سازی تمرین',

  finalizeMsg:
    'توجه داشته باشید که بعد از نهایی سازی تمرین امکان ویرایش لیست نفرات شرکت کننده وجود ندارد.',

  start: 'زمان آغاز مهلت آپلود تمرین',
  end: 'زمان پایان مهلت آپلود تمرین',
  waitForResult: 'در انتظار تصحیح و اعلام نمرات',
  notStart: 'تمرین موردنظر هنوز شروع نشده است',
  resultReady: 'مشاهده نمرات',
  inProgress: 'تمرین شروع شده است',
  startHW: 'رفتن به تمرین',
  mark: 'نمره مدنظر',
  markHelp: 'نمره مدنظر (عدد صحیح بین ۰ تا ۱۰۰)',
  markDesc: 'توضیحات نمره',
  markDescHelp: 'توضیحات نمره (اختیاری - حداکثر ۳۰۰ کاراکتر)',
  markConst: 'نمره باید بین ۰ تا ۱۰۰ باشد',
  markDescConst: 'توضیحات نمره باید کمتر از ۳۰۰ کاراکتر باشد',
};

export default translator;
